// extracted by mini-css-extract-plugin
export var infoRow = "_kj-2";
export var labelContainer = "_kj-0";
export var rightInfo = "_kj-1";